<template>
    <div class="JUS3">
        <div class="JUS3-top">
            <div class="JUS3-top-inner">
                <div class="JUS3-title">ON STYLE LIVE 입점신청</div>
                <div class="JUS3-text"><span class="span1">01.약관동의</span>&nbsp;<span
                        class="span2">>&nbsp;02.정책동의</span>&nbsp;<span class="span3">>&nbsp;03.정보입력</span></div>
            </div>
        </div>
        <div class="JUS3-bottom">
            <div class="JUS3-bottom-title">가입정보 입력</div>
            <hr>
            <div class="JUS3-bottom-cont1">
                <span class="title">업종:</span>
                <select name="category">
                    <option value="0" selected>여성의류</option>
                    <option value="0">남성의류</option>
                    <option value="0">여성가방</option>
                    <option value="0">남성가방</option>
                    <option value="0">여성신발</option>
                    <option value="0">남성신발</option>
                    <option value="0">쥬얼리/악세사리</option>
                    <option value="0">뷰티/헤어</option>
                </select>
                <span class="notice">* 여러 업종일 경우 메인 업종만 선택하세요.</span>
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="[필수] 상호명을 입력하세요">
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="한글상호명을 입력하세요(상호명이 영문으로 되어있을시에만 해당)">
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="[필수] 실제 담당자 성함">
                <span class="input-notice">* 위 성함은 외부로 유출되지 않습니다.</span>
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="[필수] 연락번호(실제 담당자의 연락번호를 기재하세요)">
                <span class="input-notice">* 위 번호는 외부로 유출되지 않습니다.</span>
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="[필수] E-mail(실제 담당자의 E-mail을 기재하세요)">
                <span class="input-notice">* 위 메일은 외부로 유출되지 않습니다.</span>
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="[필수] 고객센터 번호">
                <span class="input-notice">* 고객문의를 원활히 연결할수 있도록 고객센터 번호를 입력해주세요.<br>
                    * 잘못된 번호를 가입하면 입점심사 과정에서 불이익이 발생할수 있습니다.</span>
            </div>
            <div class="JUS3-inputbox">
                <input type="text" placeholder="[필수] 사업자등록번호">
            </div>
            <div class="JUS3-photo">
                <span>사업자 등록증:</span>
                <button>사진 업로드</button>
            </div>
            <div class="JUS3-photo">
                <span>통신판매업증:</span>
                <button>사진 업로드</button>
            </div>
            <div class="JUS3-description">
                입점 신청후 5일이내에 입점 가능 여부를 입력하신 메일로 안내해드립니다.<br>
                고객센터: 070-8873-8126 평일: 10:00 ~ 18:00 ( 토/일/공휴일 휴무,점심시간: 11:30 ~ 12:30)
            </div>
            <div class="JUS3-btn" @click="sucsess">
                <span>입점신청</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "JoinUsStep3",
        methods :{
            sucsess(){
                alert("입점신청 완료되었습니다.")
            }
        }
    }
</script>
<style lang="scss" scoped>
    .JUS3 {
        width: 100%;
        height: 100%;
        position: relative;

        .JUS3-top {
            width: 100%;
            height: 100px;
            background-color: #ffffff;
            margin-bottom: 50px;
            position: relative;

            .JUS3-top-inner {
                width: 1400px;
                height: 100%;
                margin: auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .JUS3-title {
                    font-size: 30px;
                    font-weight: 700;
                    color: #525252;
                }

                .JUS3-text {
                    font-size: 20px;
                    font-weight: 700;
                    color: #a1a1a1;

                    .span1,
                    .span2,
                    .span3 {
                        font-weight: 700;
                        color: #97b9b1;
                    }
                }
            }
        }

        .JUS3-bottom {
            width: 1200px;
            margin: auto;
            padding: 50px 50px 80px 50px;
            box-sizing: border-box;
            background-color: #ffffff;
            position: relative;

            .JUS3-bottom-title {
                font-size: 24px;
                font-weight: 900;
                color: #525252;
                margin-bottom: 20px;
            }

            hr {
                margin-bottom: 50px;
            }

            .JUS3-bottom-cont1 {
                margin-bottom: 40px;

                .title {
                    font-size: 20px;
                    font-weight: 600;
                    margin-right: 20px;
                }

                select {
                    padding: 5px 20px;
                    font-size: 18px;
                    margin-right: 10px;
                }

                .notice {
                    font-size: 16px;
                    color: red;
                }
            }

            .JUS3-inputbox {
                width: 100%;
                position: relative;
                margin-bottom: 30px;

                input {
                    font-size: 20px;
                    width: 100%;
                    height: 50px;
                    border: none;
                    border-bottom: 1px solid #a1a1a1;

                    &::placeholder {
                        color: #a1a1a1;
                    }
                }

                .input-notice {
                    font-size: 14px;
                    color: red;
                }
            }

            .JUS3-photo {
                margin-bottom: 30px;

                span {
                    font-size: 20px;
                    font-weight: 600;
                    margin-right: 20px;
                }

                button {
                    font-size: 18px;
                    padding: 5px 20px;
                    cursor: pointer;
                }
            }

            .JUS3-description {
                font-size: 20px;
                line-height: 30px;
                color: #a1a1a1;
            }

            .JUS3-btn {
                width: 100%;
                text-align: center;
                margin-top: 70px;

                span {
                    font-size: 18px;
                    padding: 20px 80px;
                    background-color: #97b9b2;
                    color: #ffffff;
                    cursor: pointer;

                    &:hover {
                        background-color: #4f6f68;
                    }
                }
            }
        }
    }
</style>